var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecorexpublicaplayFinalwhiteSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Secorex_publica_play_Final_SVG",
    "data-name": "Secorex publica play Final SVG",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1171.86,
    height: 187.26,
    viewBox: "0 0 1171.86 187.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M120.37,76.98H91.04C90.43,63.54,78.52,54.37,61.1,54.37c-15.89,0-27.49,7.94-27.49,19.25C33.61,89.2,47.36,91.64,64.77,95c21.38,3.97,59.27,10.39,59.27,46.44,0,27.19-25.66,45.82-61.71,45.82S.31,168.02,0,140.22H30.55c.61,14.36,14.05,23.83,32.69,23.83,17.41,0,29.94-8.25,29.94-20.77,0-15.58-14.97-18.02-32.08-21.08C38.49,118.84,2.75,112.12,2.75,76.68c0-27.19,23.83-45.21,58.96-45.21s58.66,18.64,58.66,45.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M312.22,119.14H183.91c3.97,25.05,23.52,42.46,49.49,42.46,21.38,0,38.43-7.58,44.23-25.6h31c-8.55,33.3-38.58,51.26-75.54,51.26-46.44,0-80.35-32.69-80.35-77.9s33.92-77.9,80.35-77.9,79.73,32.69,80.04,78.21a49.813,49.813,0,0,1-.92,9.47ZM184.83,95h98.06c-5.19-22.3-24.75-37.88-49.49-37.88S190.32,72.7,184.83,95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M420.06,187.26c-46.44,0-80.35-32.69-80.35-77.9s33.91-77.9,80.35-77.9c40.94,0,69.99,18.97,74.57,56.54h-29c-7-23-22.36-29.35-45.57-29.35-28.11,0-48.27,21.38-48.27,50.71s20.16,50.71,48.27,50.71c23.52,0,39.57-7.07,45.57-29.07h29C490.05,168.88,460.99,187.26,420.06,187.26Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M684.93,109.36c0,45.21-33.6,77.9-80.04,77.9s-80.35-32.69-80.35-77.9,33.91-77.9,80.35-77.9,80.04,32.69,80.04,77.9Zm-128.31,0c0,29.63,20.16,50.71,47.96,50.71s48.27-21.08,48.27-50.71-20.16-50.71-48.27-50.71-47.96,21.38-47.96,50.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M718.84,184.51V92.25c0-36.66,25.05-58.04,68.43-58.04V60.48c-23.22,0-36.97,11.91-36.97,34.52v89.51H718.83Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M963.23,119.14H834.92c3.97,25.05,23.52,42.46,49.49,42.46,21.38,0,40.41-7.58,46.22-25.6h31c-8.55,33.3-40.56,51.26-77.52,51.26-46.44,0-80.35-32.69-80.35-77.9s33.91-77.9,80.35-77.9,79.73,32.69,80.04,78.21a49.815,49.815,0,0,1-.92,9.47ZM835.84,95H933.9c-5.19-22.3-24.75-37.88-49.49-37.88S841.33,72.7,835.84,95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1105.91,184.51l-45.52-58.66-45.21,58.66H978.83l59.27-75.46L979.75,34.2h36.05l44.6,57.13L1105,34.2h36.35L1083,109.05l58.96,75.46h-36.05Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2050",
    "data-name": "Group 2050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M1115.25,21.59,1171.86,0l-8.55,57.63-9.94-34.9Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecorexpublicaplayFinalwhiteSvg);
export default __webpack_public_path__ + "static/media/Secorex publica play Final white SVG.b314829172f3d1ff4162461675b36e9d.svg";
export { ForwardRef as ReactComponent };